import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { getInnerRouterPath } from '@app/app.reducer';

@Component({
  selector: 'mojo-collection-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() text: string;
  @Input() counter: number;
  @Input() singleTabNotes: boolean;
  @Input() colorTitle = false;

  currentRoute$ = this.store.pipe(select(getInnerRouterPath));

  constructor(private store: Store) {}
}
